import { Page } from 'next'
import { Hero } from '~/pages/homepage/components/hero'
import { FeatureList } from '~/pages/homepage/components/feature-list'
import { FeatureSection } from '../../../components/feature-section'
import { HomepageLayout } from '~/pages/homepage/layouts/homepage-layout'
import { ProductImage } from '~/pages/homepage/components/product-image'
import { RetinaImage } from '~/pages/homepage/components/retina-image'

import thankYouNoteImage from './assets/thank-you-note.png'
import convertToMonthlyImage from './assets/convert-to-monthly.png'
import creditCardRenewalImage from './assets/credit-card-renewal.png'
import heroImage from './assets/hero.png'

export const Automations: Page = () => {
  return (
    <>
      <div className="bg-[#E9F8FF] pb-40">
        <Hero
          title={'Email and Text \nAutomations'}
          description="Reach the right supporters at the right time. Our action-trigged automations are always on and working for you, even while you sleep."
        >
          <div className="inline-flex lg:translate-x-12 lg:min-w-[748px]">
            <RetinaImage
              src={heroImage}
              alt="Kindest automation editor"
              priority
            />
          </div>
        </Hero>
        <FeatureList
          id="features"
          features={[
            {
              title: 'Text and Email Automations',
              description:
                "Approach your supporters with one-to-one text messages and emails to strengthen your donors' loyalty.",
            },
            {
              title: 'Fully Customizable',
              description:
                'Use our editor to edit logos and branding. Tailor the wording to your donor base. Our automations are fully customizable.',
            },
            {
              title: 'Behavior Based',
              description:
                'Each automation is trigged by donor behavior, making sure that supporters receive the right information at the right time.',
            },
          ]}
        />
      </div>
      <FeatureSection
        id="thank-you-note"
        label="Custom Thank You Note"
        title="Say Thank You to New Donors, Properly"
        description="A new donation is the start of a new relationship with your donor. Send a personalized thank you note with an official tax receipt and get off on the right foot."
      >
        <ProductImage src={thankYouNoteImage} alt="" />
      </FeatureSection>
      <FeatureSection
        id="credit-card-expiration"
        label="Card Expiration and Renewal"
        title="Credit Card That Never Expires"
        description="When a card is approaching its expiration, donors receive an email to update the payment method. If they don’t, our automatic card renewal system will switch to their new card by itself."
        reverse
      >
        <ProductImage src={creditCardRenewalImage} alt="" />
      </FeatureSection>
      <FeatureSection
        id="convert-to-monthly"
        label="Convert to Monthly"
        title="Convert One-Time Donors to Recurring"
        description="Increase your recurring giving. 7 days after a new one-time donation has been made, an email is sent asking the donor for continuous support."
      >
        <ProductImage src={convertToMonthlyImage} alt="" />
      </FeatureSection>

      <div className="bg-[#FFEAD7] py-20 md:py-36">
        <FeatureList
          id="other-automations"
          title="More Kindest Automations"
          features={[
            {
              title: 'Donation Dedication',
              description:
                'Email is sent to a person associated with donation dedication made in honor or in memory of someone.',
            },
            {
              title: 'New Donor Welcome',
              description:
                'Email and SMS to a new donor 24 hours after they make their first time donation to your organization.',
            },
            {
              title: 'Monthly Donation Repair',
              description:
                'After monthly donation fails to collect a payment donor receives an email with option to update their payment method.',
            },
            {
              title: 'Monthly Donation Canceled',
              description:
                'Sent as a confirmation after canceling a monthly donation. Donor has an option to restart their monthly donation.',
            },
            {
              title: 'Restart Monthly Donation',
              description:
                'Sent one month after canceling a monthly donation asking the donor to consider restarting.',
            },
            {
              title: 'Personalized Reply',
              description:
                'Email is sent when replied from the dashboard with your personalized message.',
            },
          ]}
        />
      </div>
    </>
  )
}

Automations.getLayout = HomepageLayout
